
<div class="footer">
    <p class="text-muted">
        <strong>Copyright </strong>&copy; RSMS {{currentYear}}  All rights reserved &nbsp; {{releaseVersionService.getReleaseVersion()}} 
    </p>
</div>
